/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  AgreementAction,
  AgreementActionOptional,
  AgreementActionMetaI,
  AgreementActionTrackedI,
} from "./agreement-action";
import {
  AgreementActionTracked,
  AgreementActionMeta,
} from "./agreement-action";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonNameInfo,
  PersonNameInfoOptional,
  PersonNameInfoMetaI,
  PersonNameInfoTrackedI,
} from "./person-name-info";
import { PersonNameInfoTracked, PersonNameInfoMeta } from "./person-name-info";

/**
 *
 * @export
 * @interface PersonAgreementInstanceBase
 */
export interface PersonAgreementInstanceBaseOptional extends PersonNameInfoOptional {
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  prefix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  first?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  middle?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  last?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  suffix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  preferred?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  organization?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  agreedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  agreementExpiration?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  ipAddress?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  userAgent?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  email?: string;
  /**
   *
   * @type {AgreementAction}
   * @memberof PersonAgreementInstanceBase
   */
  agreementAction?: AgreementAction;
}

export interface PersonAgreementInstanceBase
  extends PersonAgreementInstanceBaseOptional, PersonNameInfo {
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  prefix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  first?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  middle?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  last?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  suffix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  preferred?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  organization?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  agreedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  agreementExpiration?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  ipAddress?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  userAgent?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  email?: string;
  /**
   *
   * @type {AgreementAction}
   * @memberof PersonAgreementInstanceBase
   */
  agreementAction?: AgreementAction;
}

export interface PersonAgreementInstanceBaseTrackedI extends PersonNameInfoOptional {
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  prefix?: string;
  prefixIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  first?: string;
  firstIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  middle?: string;
  middleIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  last?: string;
  lastIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  suffix?: string;
  suffixIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  preferred?: string;
  preferredIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  organization?: string;
  organizationIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  agreedOn?: Date;
  agreedOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  agreementExpiration?: Date;
  agreementExpirationIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  ipAddress?: string;
  ipAddressIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  userAgent?: string;
  userAgentIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceBase
   */
  email?: string;
  emailIsSet: boolean;
  /**
   *
   * @type {AgreementAction}
   * @memberof PersonAgreementInstanceBase
   */
  agreementAction?: AgreementAction;
  agreementActionIsSet: boolean;
}

transformDatesMap.set(
  "PersonAgreementInstanceBase",
  function (model: PersonAgreementInstanceBase) {
    if (typeof model.agreedOn == "string")
      model.agreedOn = new Date(model.agreedOn);
    if (typeof model.agreementExpiration == "string")
      model.agreementExpiration = new Date(model.agreementExpiration);
  },
);

export type PersonAgreementInstanceBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  prefix: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  first: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  middle: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  last: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  suffix: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  preferred: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  organization: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  agreedOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  agreementExpiration: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  ipAddress: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  userAgent: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  email: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  agreementAction: PropertyMeta<AgreementActionMetaI>;
}>;

export var PersonAgreementInstanceBaseMeta: PersonAgreementInstanceBaseMetaI =
  {} as PersonAgreementInstanceBaseMetaI;
PersonAgreementInstanceBaseMeta = typeMeta("PersonAgreementInstanceBase", {
  prefix: propertyMeta("prefix", false, false, false, MetaTypesBase.string),
  first: propertyMeta("first", false, false, false, MetaTypesBase.string),
  middle: propertyMeta("middle", false, false, false, MetaTypesBase.string),
  last: propertyMeta("last", false, false, false, MetaTypesBase.string),
  suffix: propertyMeta("suffix", false, false, false, MetaTypesBase.string),
  preferred: propertyMeta(
    "preferred",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  organization: propertyMeta(
    "organization",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  agreedOn: propertyMeta("agreedOn", false, false, false, MetaTypesBase.Date),
  agreementExpiration: propertyMeta(
    "agreementExpiration",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  ipAddress: propertyMeta(
    "ipAddress",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  userAgent: propertyMeta(
    "userAgent",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  email: propertyMeta("email", false, false, false, MetaTypesBase.string),
  agreementAction: propertyMeta(
    "agreementAction",
    false,
    false,
    false,
    AgreementActionMeta,
  ),
});

const metaI = PersonAgreementInstanceBaseMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([PersonNameInfoMeta]);
  metaI.prefix.inheritedFrom = PersonNameInfoMeta.prefix;
  metaI.first.inheritedFrom = PersonNameInfoMeta.first;
  metaI.middle.inheritedFrom = PersonNameInfoMeta.middle;
  metaI.last.inheritedFrom = PersonNameInfoMeta.last;
  metaI.suffix.inheritedFrom = PersonNameInfoMeta.suffix;
  metaI.preferred.inheritedFrom = PersonNameInfoMeta.preferred;
  metaI.organization.inheritedFrom = PersonNameInfoMeta.organization;
});

export class PersonAgreementInstanceBaseTracked
  extends PersonNameInfoTracked
  implements PersonAgreementInstanceBaseTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  prefix__I?: string = undefined;
  prefixIsSet: boolean = false;
  set prefix(v: undefined | string) {
    if (v !== undefined) {
      this.prefix__I = v;
      this.prefixIsSet = true;
    } else {
      this.prefix__I = v || undefined;
      this.prefixIsSet = false;
    }
    this.changeTracker = true;
  }
  get prefix() {
    return this.prefix__I;
  }
  first__I?: string = undefined;
  firstIsSet: boolean = false;
  set first(v: undefined | string) {
    if (v !== undefined) {
      this.first__I = v;
      this.firstIsSet = true;
    } else {
      this.first__I = v || undefined;
      this.firstIsSet = false;
    }
    this.changeTracker = true;
  }
  get first() {
    return this.first__I;
  }
  middle__I?: string = undefined;
  middleIsSet: boolean = false;
  set middle(v: undefined | string) {
    if (v !== undefined) {
      this.middle__I = v;
      this.middleIsSet = true;
    } else {
      this.middle__I = v || undefined;
      this.middleIsSet = false;
    }
    this.changeTracker = true;
  }
  get middle() {
    return this.middle__I;
  }
  last__I?: string = undefined;
  lastIsSet: boolean = false;
  set last(v: undefined | string) {
    if (v !== undefined) {
      this.last__I = v;
      this.lastIsSet = true;
    } else {
      this.last__I = v || undefined;
      this.lastIsSet = false;
    }
    this.changeTracker = true;
  }
  get last() {
    return this.last__I;
  }
  suffix__I?: string = undefined;
  suffixIsSet: boolean = false;
  set suffix(v: undefined | string) {
    if (v !== undefined) {
      this.suffix__I = v;
      this.suffixIsSet = true;
    } else {
      this.suffix__I = v || undefined;
      this.suffixIsSet = false;
    }
    this.changeTracker = true;
  }
  get suffix() {
    return this.suffix__I;
  }
  preferred__I?: string = undefined;
  preferredIsSet: boolean = false;
  set preferred(v: undefined | string) {
    if (v !== undefined) {
      this.preferred__I = v;
      this.preferredIsSet = true;
    } else {
      this.preferred__I = v || undefined;
      this.preferredIsSet = false;
    }
    this.changeTracker = true;
  }
  get preferred() {
    return this.preferred__I;
  }
  organization__I?: string = undefined;
  organizationIsSet: boolean = false;
  set organization(v: undefined | string) {
    if (v !== undefined) {
      this.organization__I = v;
      this.organizationIsSet = true;
    } else {
      this.organization__I = v || undefined;
      this.organizationIsSet = false;
    }
    this.changeTracker = true;
  }
  get organization() {
    return this.organization__I;
  }
  agreedOn__I?: Date = undefined;
  agreedOnIsSet: boolean = false;
  set agreedOn(v: undefined | Date) {
    if (v !== undefined) {
      this.agreedOn__I = v;
      this.agreedOnIsSet = true;
    } else {
      this.agreedOn__I = v || undefined;
      this.agreedOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreedOn() {
    return this.agreedOn__I;
  }
  agreementExpiration__I?: Date = undefined;
  agreementExpirationIsSet: boolean = false;
  set agreementExpiration(v: undefined | Date) {
    if (v !== undefined) {
      this.agreementExpiration__I = v;
      this.agreementExpirationIsSet = true;
    } else {
      this.agreementExpiration__I = v || undefined;
      this.agreementExpirationIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementExpiration() {
    return this.agreementExpiration__I;
  }
  ipAddress__I?: string = undefined;
  ipAddressIsSet: boolean = false;
  set ipAddress(v: undefined | string) {
    if (v !== undefined) {
      this.ipAddress__I = v;
      this.ipAddressIsSet = true;
    } else {
      this.ipAddress__I = v || undefined;
      this.ipAddressIsSet = false;
    }
    this.changeTracker = true;
  }
  get ipAddress() {
    return this.ipAddress__I;
  }
  userAgent__I?: string = undefined;
  userAgentIsSet: boolean = false;
  set userAgent(v: undefined | string) {
    if (v !== undefined) {
      this.userAgent__I = v;
      this.userAgentIsSet = true;
    } else {
      this.userAgent__I = v || undefined;
      this.userAgentIsSet = false;
    }
    this.changeTracker = true;
  }
  get userAgent() {
    return this.userAgent__I;
  }
  email__I?: string = undefined;
  emailIsSet: boolean = false;
  set email(v: undefined | string) {
    if (v !== undefined) {
      this.email__I = v;
      this.emailIsSet = true;
    } else {
      this.email__I = v || undefined;
      this.emailIsSet = false;
    }
    this.changeTracker = true;
  }
  get email() {
    return this.email__I;
  }
  agreementAction__I?: AgreementAction = undefined;
  agreementActionIsSet: boolean = false;
  set agreementAction(v: undefined | AgreementAction) {
    if (v !== undefined) {
      this.agreementAction__I = v;
      this.agreementActionIsSet = true;
    } else {
      this.agreementAction__I = v || undefined;
      this.agreementActionIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementAction() {
    return this.agreementAction__I;
  }
  constructor(
    config?: PersonAgreementInstanceBaseOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: PersonAgreementInstanceBaseOptional,
    options?: AssignOptions,
  ): PersonAgreementInstanceBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.prefix && this.prefixApplyFilter(optionsRequired.filter)) {
      this.prefix = config.prefix;
      if (optionsRequired.unassign) this.prefixIsSet = false;
      else this.prefixIsSet = true;
    }
    if (config.first && this.firstApplyFilter(optionsRequired.filter)) {
      this.first = config.first;
      if (optionsRequired.unassign) this.firstIsSet = false;
      else this.firstIsSet = true;
    }
    if (config.middle && this.middleApplyFilter(optionsRequired.filter)) {
      this.middle = config.middle;
      if (optionsRequired.unassign) this.middleIsSet = false;
      else this.middleIsSet = true;
    }
    if (config.last && this.lastApplyFilter(optionsRequired.filter)) {
      this.last = config.last;
      if (optionsRequired.unassign) this.lastIsSet = false;
      else this.lastIsSet = true;
    }
    if (config.suffix && this.suffixApplyFilter(optionsRequired.filter)) {
      this.suffix = config.suffix;
      if (optionsRequired.unassign) this.suffixIsSet = false;
      else this.suffixIsSet = true;
    }
    if (config.preferred && this.preferredApplyFilter(optionsRequired.filter)) {
      this.preferred = config.preferred;
      if (optionsRequired.unassign) this.preferredIsSet = false;
      else this.preferredIsSet = true;
    }
    if (
      config.organization &&
      this.organizationApplyFilter(optionsRequired.filter)
    ) {
      this.organization = config.organization;
      if (optionsRequired.unassign) this.organizationIsSet = false;
      else this.organizationIsSet = true;
    }
    if (config.agreedOn && this.agreedOnApplyFilter(optionsRequired.filter)) {
      this.agreedOn = config.agreedOn;
      if (optionsRequired.unassign) this.agreedOnIsSet = false;
      else this.agreedOnIsSet = true;
    }
    if (
      config.agreementExpiration &&
      this.agreementExpirationApplyFilter(optionsRequired.filter)
    ) {
      this.agreementExpiration = config.agreementExpiration;
      if (optionsRequired.unassign) this.agreementExpirationIsSet = false;
      else this.agreementExpirationIsSet = true;
    }
    if (config.ipAddress && this.ipAddressApplyFilter(optionsRequired.filter)) {
      this.ipAddress = config.ipAddress;
      if (optionsRequired.unassign) this.ipAddressIsSet = false;
      else this.ipAddressIsSet = true;
    }
    if (config.userAgent && this.userAgentApplyFilter(optionsRequired.filter)) {
      this.userAgent = config.userAgent;
      if (optionsRequired.unassign) this.userAgentIsSet = false;
      else this.userAgentIsSet = true;
    }
    if (config.email && this.emailApplyFilter(optionsRequired.filter)) {
      this.email = config.email;
      if (optionsRequired.unassign) this.emailIsSet = false;
      else this.emailIsSet = true;
    }
    if (
      config.agreementAction &&
      this.agreementActionApplyFilter(optionsRequired.filter)
    ) {
      this.agreementAction = config.agreementAction;
      if (optionsRequired.unassign) this.agreementActionIsSet = false;
      else this.agreementActionIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonAgreementInstanceBaseTrackedI {
    const cloned = {} as PersonAgreementInstanceBaseTrackedI;
    if (
      this.prefixIsSetDeep() &&
      this.prefixApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.prefixIsSet = true;
      cloned.prefix = this.prefix;
    } else {
      //cloned.prefixIsSet = false
    }
    if (
      this.firstIsSetDeep() &&
      this.firstApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.firstIsSet = true;
      cloned.first = this.first;
    } else {
      //cloned.firstIsSet = false
    }
    if (
      this.middleIsSetDeep() &&
      this.middleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.middleIsSet = true;
      cloned.middle = this.middle;
    } else {
      //cloned.middleIsSet = false
    }
    if (
      this.lastIsSetDeep() &&
      this.lastApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.lastIsSet = true;
      cloned.last = this.last;
    } else {
      //cloned.lastIsSet = false
    }
    if (
      this.suffixIsSetDeep() &&
      this.suffixApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.suffixIsSet = true;
      cloned.suffix = this.suffix;
    } else {
      //cloned.suffixIsSet = false
    }
    if (
      this.preferredIsSetDeep() &&
      this.preferredApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.preferredIsSet = true;
      cloned.preferred = this.preferred;
    } else {
      //cloned.preferredIsSet = false
    }
    if (
      this.organizationIsSetDeep() &&
      this.organizationApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.organizationIsSet = true;
      cloned.organization = this.organization;
    } else {
      //cloned.organizationIsSet = false
    }
    if (
      this.agreedOnIsSetDeep() &&
      this.agreedOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreedOnIsSet = true;
      cloned.agreedOn = this.agreedOn;
    } else {
      //cloned.agreedOnIsSet = false
    }
    if (
      this.agreementExpirationIsSetDeep() &&
      this.agreementExpirationApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementExpirationIsSet = true;
      cloned.agreementExpiration = this.agreementExpiration;
    } else {
      //cloned.agreementExpirationIsSet = false
    }
    if (
      this.ipAddressIsSetDeep() &&
      this.ipAddressApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.ipAddressIsSet = true;
      cloned.ipAddress = this.ipAddress;
    } else {
      //cloned.ipAddressIsSet = false
    }
    if (
      this.userAgentIsSetDeep() &&
      this.userAgentApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.userAgentIsSet = true;
      cloned.userAgent = this.userAgent;
    } else {
      //cloned.userAgentIsSet = false
    }
    if (
      this.emailIsSetDeep() &&
      this.emailApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.emailIsSet = true;
      cloned.email = this.email;
    } else {
      //cloned.emailIsSet = false
    }
    if (
      this.agreementActionIsSetDeep() &&
      this.agreementActionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementActionIsSet = true;
      cloned.agreementAction = this.agreementAction;
    } else {
      //cloned.agreementActionIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonAgreementInstanceBaseTrackedI {
    if (!this.prefixApplyFilter(filter)) this.prefixIsSet = false;

    if (!this.firstApplyFilter(filter)) this.firstIsSet = false;

    if (!this.middleApplyFilter(filter)) this.middleIsSet = false;

    if (!this.lastApplyFilter(filter)) this.lastIsSet = false;

    if (!this.suffixApplyFilter(filter)) this.suffixIsSet = false;

    if (!this.preferredApplyFilter(filter)) this.preferredIsSet = false;

    if (!this.organizationApplyFilter(filter)) this.organizationIsSet = false;

    if (!this.agreedOnApplyFilter(filter)) this.agreedOnIsSet = false;

    if (!this.agreementExpirationApplyFilter(filter))
      this.agreementExpirationIsSet = false;

    if (!this.ipAddressApplyFilter(filter)) this.ipAddressIsSet = false;

    if (!this.userAgentApplyFilter(filter)) this.userAgentIsSet = false;

    if (!this.emailApplyFilter(filter)) this.emailIsSet = false;

    if (!this.agreementActionApplyFilter(filter))
      this.agreementActionIsSet = false;

    return this;
  }
  prefixApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceBaseMeta.prefix,
      PersonAgreementInstanceBaseMeta,
      this.prefix,
      this,
    );
  }
  prefixIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.prefixIsSet && this.prefixApplyFilter(filter)) return true;

    return false;
  }
  firstApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceBaseMeta.first,
      PersonAgreementInstanceBaseMeta,
      this.first,
      this,
    );
  }
  firstIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.firstIsSet && this.firstApplyFilter(filter)) return true;

    return false;
  }
  middleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceBaseMeta.middle,
      PersonAgreementInstanceBaseMeta,
      this.middle,
      this,
    );
  }
  middleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.middleIsSet && this.middleApplyFilter(filter)) return true;

    return false;
  }
  lastApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceBaseMeta.last,
      PersonAgreementInstanceBaseMeta,
      this.last,
      this,
    );
  }
  lastIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.lastIsSet && this.lastApplyFilter(filter)) return true;

    return false;
  }
  suffixApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceBaseMeta.suffix,
      PersonAgreementInstanceBaseMeta,
      this.suffix,
      this,
    );
  }
  suffixIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.suffixIsSet && this.suffixApplyFilter(filter)) return true;

    return false;
  }
  preferredApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceBaseMeta.preferred,
      PersonAgreementInstanceBaseMeta,
      this.preferred,
      this,
    );
  }
  preferredIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.preferredIsSet && this.preferredApplyFilter(filter)) return true;

    return false;
  }
  organizationApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceBaseMeta.organization,
      PersonAgreementInstanceBaseMeta,
      this.organization,
      this,
    );
  }
  organizationIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.organizationIsSet && this.organizationApplyFilter(filter))
      return true;

    return false;
  }
  agreedOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceBaseMeta.agreedOn,
      PersonAgreementInstanceBaseMeta,
      this.agreedOn,
      this,
    );
  }
  agreedOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.agreedOnIsSet && this.agreedOnApplyFilter(filter)) return true;

    return false;
  }
  agreementExpirationApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceBaseMeta.agreementExpiration,
      PersonAgreementInstanceBaseMeta,
      this.agreementExpiration,
      this,
    );
  }
  agreementExpirationIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.agreementExpirationIsSet &&
      this.agreementExpirationApplyFilter(filter)
    )
      return true;

    return false;
  }
  ipAddressApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceBaseMeta.ipAddress,
      PersonAgreementInstanceBaseMeta,
      this.ipAddress,
      this,
    );
  }
  ipAddressIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.ipAddressIsSet && this.ipAddressApplyFilter(filter)) return true;

    return false;
  }
  userAgentApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceBaseMeta.userAgent,
      PersonAgreementInstanceBaseMeta,
      this.userAgent,
      this,
    );
  }
  userAgentIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.userAgentIsSet && this.userAgentApplyFilter(filter)) return true;

    return false;
  }
  emailApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceBaseMeta.email,
      PersonAgreementInstanceBaseMeta,
      this.email,
      this,
    );
  }
  emailIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.emailIsSet && this.emailApplyFilter(filter)) return true;

    return false;
  }
  agreementActionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceBaseMeta.agreementAction,
      PersonAgreementInstanceBaseMeta,
      this.agreementAction,
      this,
    );
  }
  agreementActionIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.agreementActionIsSet && this.agreementActionApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.prefixIsSetDeep(filter)) return true;
    if (this.firstIsSetDeep(filter)) return true;
    if (this.middleIsSetDeep(filter)) return true;
    if (this.lastIsSetDeep(filter)) return true;
    if (this.suffixIsSetDeep(filter)) return true;
    if (this.preferredIsSetDeep(filter)) return true;
    if (this.organizationIsSetDeep(filter)) return true;
    if (this.agreedOnIsSetDeep(filter)) return true;
    if (this.agreementExpirationIsSetDeep(filter)) return true;
    if (this.ipAddressIsSetDeep(filter)) return true;
    if (this.userAgentIsSetDeep(filter)) return true;
    if (this.emailIsSetDeep(filter)) return true;
    if (this.agreementActionIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
